const convertRate = (
  value,
  exchangeRate,
  originExchangeRate = 1,
  numberFormat = 1,
  rounded = false
) => {
  let result = (value * exchangeRate) / originExchangeRate / numberFormat;

  result = rounded ? parseFloat(result).toFixed(1) : result;

  return isNaN(parseFloat(result)) ? 0 : parseFloat(result);
};

export default convertRate;
